import { ChangeDetectionStrategy, Component, OnInit, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TabsModule } from 'primeng/tabs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { KpiService, Supervisee } from 'src/app/api/kpi.service';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { UiSafeStaff } from 'src/app/api';
import { map } from 'rxjs/operators';
import { UiModule } from 'src/app/ui/ui.module';
import { MyPotentialTripsComponent } from '../../departments/recruiting/my-potential-trips/my-potential-trips.component';
import { MyConsultingWrapperComponent } from '../../departments/consulting/my-consulting-wrapper/my-consulting-wrapper.component';
import { MyOverduePaymentsComponent } from '../../departments/consulting/my-overdue-payments/my-overdue-payments.component';
import { MyOverdueRegiFeesComponent } from '../../departments/recruiting/my-overdue-regi-fees/my-overdue-regi-fees.component';
import { AllScheduledActivitiesComponent } from '../../common/all-scheduled-activities/all-scheduled-activities.component';
import { RecruitingScheduledActivitiesComponent } from '../../departments/recruiting/recruiting-scheduled-activities/recruiting-scheduled-activities.component';
import { ConsultingScheduledActivitiesComponent } from '../../departments/consulting/consulting-scheduled-activities/consulting-scheduled-activities.component';
import { PartnerScheduledActivitiesComponent } from '../../roots/partner-scheduled-activities/partner-scheduled-activities.component';

@Component({
  selector: 'app-supervisor-dashboard',
  templateUrl: './supervisor-dashboard.component.html',
  styleUrls: ['./supervisor-dashboard.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    TabsModule,
    ProgressSpinnerModule,
    UiModule,
    MyPotentialTripsComponent,
    MyConsultingWrapperComponent,
    MyOverdueRegiFeesComponent,
    MyOverduePaymentsComponent,
    AllScheduledActivitiesComponent,
    RecruitingScheduledActivitiesComponent,
    ConsultingScheduledActivitiesComponent,
    PartnerScheduledActivitiesComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupervisorDashboardComponent implements OnInit {
  supervisees = signal<Supervisee[]>([]);
  loading = signal(true);
  hasSupervisees = computed(() => this.supervisees().length > 0);

  constructor(
    private kpiService: KpiService,
    private auth: LocalAuthService
  ) {}

  ngOnInit() {
    this.loadSupervisees();
  }

  private loadSupervisees() {
    const staffId = this.auth.currentUser?.newstaffId;
    if (!staffId) {
      this.loading.set(false);
      return;
    }

    this.kpiService.getDirectSupervisees(staffId)
      .pipe(
        map(supervisees => supervisees.filter(staff => staff.supervisor === staffId))
      )
      .subscribe({
        next: (supervisees) => {
          this.supervisees.set(supervisees);
          this.loading.set(false);
        },
        error: (error) => {
          this.supervisees.set([]);
          this.loading.set(false);
        }
      });
  }
} 